export default __webpack_public_path__ + "static/media/modelsorder.968e6327.jpeg";